import { useThemeStyle } from '@linqpal/common-frontend/src/hooks'

export const useBaseTextStyle = () => useThemeStyle((theme) => ({
  accent: {
    color: theme.colors.accentText,
    // TODO: Add theme fontSize for 18
    fontSize: theme.fontSizes.regular + 2,
    lineHeight: theme.lineHeights.large,
    width: '100%',
    textAlign: 'center'
  },
  bodySecondary: {
    fontSize: theme.fontSizes.regular,
    marginTop: theme.paddings.small
  },
  centerText: {
    textAlign: 'center'
  },
  mediumHeading: {
    fontSize: theme.fontSizes.regular,
    ...theme.fonts.medium
  },
  heading: {
    ...theme.fonts.bold,
    fontSize: theme.fontSizes.large,
    lineHeight: theme.lineHeights.extraLarge
  },
  titleSecondary: {
    ...theme.fonts.thin,
    fontSize: theme.fontSizes.larger,
    lineHeight: theme.fontSizes.larger
  },
  denseSubHeading: {
    ...theme.fonts.boldest,
    fontSize: theme.fontSizes.medium
  }
}));
